import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import BillPrint from '../sale/Bill';
import PrintIcon from '@mui/icons-material/Print';
import Info from '@mui/icons-material/Info';
import ReactDOM from 'react-dom';
import AddIcon from '@mui/icons-material/Add';
import CopyrightIcon from '@mui/icons-material/Copyright';
import RefreshIcon from '@mui/icons-material/Refresh';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logo from '../logo/swarovski-1.png';

function SaleIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const history = useHistory(); // Access the navigation history
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');

    const { isAuthenticated, companyId, branchId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Transaction');
    const hasEditMasterPermission = permissions.includes('Edit Transaction');
    const hasDeleteMasterPermission = permissions.includes('Delete Transaction');

    useEffect(() => {
        // Check if the token is expired
        if (isAuthenticated && tokenIsExpired(token)) {
            // Token is expired, log out the user
            logout();
            return;
        }
        setFromDate(getFormattedStartDate());
        setToDate(getFormattedCurrentDate());
        // Token is not expired, fetch data
        fetchTableData();
    }, [isAuthenticated, companyId, branchId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);
    //handle search
    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const getFormattedCurrentDate = () => {
        const currentDate = new Date();
        return currentDate.toISOString().split('T')[0];
    };

    const getFormattedStartDate = () => {
        const monthStartDate = new Date();
        monthStartDate.setDate(1);
        return monthStartDate.toISOString().split('T')[0];
    };


    const handleFromDateChange = (e) => {
        const selectedDate = e.target.value;
        setFromDate(selectedDate);
    };

    const handleToDateChange = (e) => {
        const selectedDate = e.target.value;
        setToDate(selectedDate);
    };

    // here 4 parameter passing to help loading the infinte no:of data in index and fast loading 

    // Function to fetch table data and set state
    const fetchTableData = async () => {

        setData([]);
        try {
            const response = await fetchData('SaleApi', `/CustomerDetails/${companyId}/${branchId}/${fromDate}/${toDate}`, token);
            if (response.responseCode === '1111') {
                setData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Customer Details:', error);
            if (error.response && error.response.status === 401) {
                logout();
                history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
            }
        }

    };



    const handleDelete = async () => {
        deleteData('SaleApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchTableData();
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('SaleApi', `${itemId}`, token)
            .then(() => {
                fetchTableData();
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    const handlePrint = async (saleid) => {
        try {

            const response = await fetchData('SaleApi', `/SalePrint/${saleid}/${branchId}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();
            // iframe.contentWindow.print();
            setTimeout(() => {
                iframe.contentWindow.print();
            }, 1000);

        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };


    // const handlePrint = async (saleId) => {
    //     try {
    //         // ===== FETCH DATA =====
    //         const response = await fetchData(
    //             "SaleApi",
    //             `/SalePrint/${saleId}/${branchId}`,
    //             token
    //         );
    //         const labelData = response.response_data;

    //         if (!labelData?.SalePrint || !labelData?.SalePrintDetails) {
    //             throw new Error("Invalid invoice data.");
    //         }

    //         const header = labelData.SalePrint;
    //         const items = labelData.SalePrintDetails;

    //         // ===== INIT PDF =====
    //         const doc = new jsPDF({ orientation: "portrait", unit: "mm", format: "a4" });
    //         const pageWidth = doc.internal.pageSize.getWidth();
    //         const pageHeight = doc.internal.pageSize.getHeight();
    //         let y = 10;

    //         doc.setTextColor(0, 0, 0); // black text

    //         // ===== LOGO & HEADER BLOCK =====
    //         const logoImg = new Image();
    //         logoImg.src = logo;
    //         await new Promise((res) => (logoImg.onload = res));

    //         // ===== LOGO & HEADER BLOCK =====
    //         // Move logo closer to the top and enlarge it
    //         doc.addImage(logoImg, "PNG", pageWidth / 2 - 12, y - 4, 20, 20);
    //         y += 19; // Adjust Y increment to match the larger size


    //         // ===== DEALER & COMPANY INFO =====
    //         let hY = y;

    //         doc.setFont("helvetica", "bold").setFontSize(11);
    //         doc.text("Dealer : SWAROVSKI", pageWidth / 2, hY, { align: "center" });
    //         hY += 6;

    //         doc.setFontSize(13);
    //         doc.text(header.CompanyName || "", pageWidth / 2, hY, { align: "center" });
    //         hY += 6;

    //         doc.setFont("helvetica", "normal").setFontSize(9);
    //         doc.text(header.AddressLine || "", pageWidth / 2, hY, { align: "center" });
    //         hY += 5;

    //         doc.text(`Phone No: ${header.ContactNumber1 || ""}`, pageWidth / 2, hY, { align: "center" });
    //         hY += 4;

    //         doc.text(`Email: ${header.Email || ""}`, pageWidth / 2, hY, { align: "center" });
    //         y += 27;

    //         // ===== STATE / INVOICE INFO =====
    //         let infoY = y;

    //         doc.setFont("helvetica", "normal").setFontSize(9);
    //         doc.setFont("helvetica", "bold").setFontSize(9);
    //         doc.text(`State Code: ${header.BranchStateCode || ""}`, 12, infoY);
    //         doc.setFont("helvetica", "normal").setFontSize(9);
    //         doc.text(`CIN Number: ${header.CINNumber || ""}`, pageWidth / 2, infoY, { align: "center" });
    //         doc.setFont("helvetica", "bold").setFontSize(9);
    //         doc.text(
    //             `Invoice No: ${header.BillPrefix || ""}/${header.BillNumber || ""}/${header.FinYear || ""}`,
    //             pageWidth - 12,
    //             infoY,
    //             { align: "right" }
    //         );

    //         infoY += 5;

    //         doc.text(`State Name: ${header.BranchStateName || ""}`, 12, infoY);
    //         doc.setFont("helvetica", "normal").setFontSize(9);
    //         doc.text(`GST Number: ${header.CompanyGSTNumber || ""}`, pageWidth / 2, infoY, { align: "center" });
    //         doc.setFont("helvetica", "bold").setFontSize(9);
    //         doc.text(
    //             `Date: ${header.BillDate
    //                 ? new Date(header.BillDate).toLocaleDateString("en-GB", {
    //                     day: "2-digit",
    //                     month: "2-digit",
    //                     year: "numeric",
    //                 })
    //                 : ""}`,
    //             pageWidth - 12,
    //             infoY,
    //             { align: "right" }
    //         );


    //         y += 13;

    //         // ===== RETAIL INVOICE TITLE =====
    //         doc.setFont("helvetica", "bold").setFontSize(12);
    //         doc.text("RETAIL INVOICE", pageWidth / 2, y, { align: "center" });
    //         y += 4;

    //         // ===== CUSTOMER DETAILS =====
    //         const customerBoxHeight = 29; // Fixed height for customer block
    //         doc.rect(10, y, pageWidth - 20, customerBoxHeight);
    //         let cY = y + 6;

    //         doc.setFont("helvetica", "bold").setFontSize(10);
    //         doc.text("Customer Name & Address", 12, cY);
    //         cY += 6;

    //         doc.setFont("helvetica", "normal").setFontSize(9);

    //         // Customer name
    //         doc.text(header.CustomerName || "", 12, cY);
    //         cY += 5;

    //         // Contact number if available
    //         if (header.ContactNumber) {
    //             doc.text(header.ContactNumber, 12, cY);
    //             cY += 5;
    //         }

    //         // Address (wrap but limited height if shorter)
    //         if (header.CustomerAddress) {
    //             const wrappedAddr = doc.splitTextToSize(header.CustomerAddress, pageWidth - 24);
    //             doc.text(wrappedAddr, 12, cY);
    //             cY += wrappedAddr.length * 5;
    //         } else {
    //             cY += 5; // add space to keep spacing uniform
    //         }

    //         // GST number (show placeholder if not available)
    //         doc.text(`GST Number: ${header.GSTNumber || "Not Available"}`, 12, cY);

    //         // Move y pointer by fixed height for table alignment
    //         y += customerBoxHeight;


    //         // ===== ITEMS TABLE =====
    //         const formatValue = (val) =>
    //             val == null || val === 0 ? "" : Number(val).toFixed(2);

    //         // Fill empty rows if needed for consistent table height
    //         const minRows = 10;
    //         const tableData = [...items];
    //         while (tableData.length < minRows) {
    //             tableData.push({});
    //         }

    //         const itemRows = tableData.map((item) => [
    //             item.Code || "",
    //             item.ItemName || "",
    //             item.HSNCode || "",
    //             formatValue(item.Rate),
    //             formatValue(item.DiscountPercentage),
    //             formatValue(item.Quantity),
    //             formatValue(item.TaxableAmount),
    //             formatValue(item.GSTRate),
    //             formatValue(item.GSTAmount),
    //             formatValue(item.TotalAmount),
    //         ]);

            

    //         // ===== CALCULATE TOTALS =====
    //         const sumAmount = items.reduce((sum, i) => sum + (i.TaxableAmount ?? 0), 0);
    //         const sumVat = items.reduce((sum, i) => sum + (i.GSTAmount ?? 0), 0);
    //         const sumTotal = items.reduce((sum, i) => sum + (i.TotalAmount ?? 0), 0);

    //         // ===== GENERATE TABLE =====
    //         autoTable(doc, {
    //             startY: y,
    //             head: [[
    //                 "CODE", "DESCRIPTION", "HSN", "MRP", "DISC %", "QTY", "RATE", "GST %", "GST", "VALUE"
    //             ]],
    //             body: items.map((item) => [
    //                 item.ItemCode || "",
    //                 item.ItemName || "",
    //                 item.HSNCode || "",
    //                 formatValue(item.MRP),
    //                 formatValue(item.DiscountPercentage),
    //                 formatValue(item.Quantity),
    //                 formatValue(item.Rate),
    //                 formatValue(item.GSTRate),
    //                 formatValue(item.GSTAmount),
    //                 formatValue(item.TotalAmount),
    //             ]),
    //             styles: {
    //                 fontSize: 8,
    //                 textColor: [0, 0, 0],
    //                 lineColor: [0, 0, 0],
    //                 lineWidth: 0.2,
    //                 cellPadding: 2
    //             },
    //             headStyles: {
    //                 fillColor: [240, 240, 240],
    //                 textColor: [0, 0, 0],
    //                 fontStyle: "bold",
    //                 lineWidth: { top: 0.2, right: 0.2, bottom: 0.3, left: 0.2 }, // ⬅ no bottom border
    //             },
    //             bodyStyles: {
    //                 halign: "right",
    //                 lineWidth: { top: 0, right: 0.2, bottom: 0, left: 0.2 },
    //             },
    //             columnStyles: {
    //                 0: { cellWidth: 15, halign: "center" }, // CODE
    //                 1: { cellWidth: 55, halign: "left" },   // DESCRIPTION
    //                 2: { cellWidth: 18, halign: "right" },  // HSN
    //                 3: { cellWidth: 15, halign: "right" },  // MRP
    //                 4: { cellWidth: 15, halign: "right" },  // DISC %
    //                 5: { cellWidth: 10, halign: "right" },  // QTY
    //                 6: { cellWidth: 15, halign: "right" },  // RATE
    //                 7: { cellWidth: 14, halign: "right" },  // GST %
    //                 8: { cellWidth: 15, halign: "right" },  // GST
    //                 9: { cellWidth: 18, halign: "right" },  // VALUE
    //             },
    //             theme: "grid",
    //             margin: { left: 10, right: 10 }
    //         });


    //         y = doc.lastAutoTable.finalY;

    //         // ===== TOTALS & SIGNATURE =====
    //         doc.rect(10, y, pageWidth - 20, 15);
    //         let tY = y + 5;

    //         const totalCGST = items.reduce((sum, i) => sum + (i.VatAmount ?? 0) / 2, 0);
    //         const totalSGST = totalCGST;
    //         const grandTotal = items.reduce((sum, i) => sum + (i.TotalAmount ?? 0), 0);

    //         doc.setFont("helvetica", "normal").setFontSize(9);
    //         doc.text(`CGST Amount: ${totalCGST.toFixed(2)}`, 12, tY);
    //         doc.text(`TOTAL AMOUNT (Inclusive of GST) ${grandTotal.toFixed(2)}`, pageWidth / 2, tY, { align: "center" });
    //         tY += 5;
    //         doc.text(`SGST Amount: ${totalSGST.toFixed(2)}`, 12, tY);

    //         y += 20;

    //         doc.text(`Rupees ${header.AmountInWords || ""}`, 12, y);
    //         doc.setFont("helvetica", "bold").setFontSize(10);
    //         doc.text("Authorised Signatory", pageWidth - 60, y);

    //         y += 12;

    //         // ===== TERMS & CONDITIONS =====
    //         doc.rect(10, y, pageWidth - 20, pageHeight - y - 10);
    //         let termY = y + 6;

    //         doc.setFont("helvetica", "bold").setFontSize(10);
    //         doc.text("Terms & Conditions", 12, termY);
    //         termY += 6;

    //         doc.setFont("helvetica", "normal").setFontSize(8);
    //         const termsText = [
    //             "If you would like to exchange your purchase for any reason, simply exchange the product with all its original packaging and the original receipt within 14 days of purchase to the original point of purchase. Swarovski Created Diamond products can be exchanged within 30 days of purchase.",
    //             "For promotional bundles, you can exchange any of the items purchased separately. However, if your exchange reduces the number of items purchased below the offer threshold, your remaining purchases will no longer qualify for the promotion and all discounts applied will be forfeited.",
    //             "Non-exchangeable Items: Products which have been personalized, engraved, adjusted for a fit, made to order, or customized cannot be returned or exchanged. Gift cards, food and beverage items and face masks cannot be returned or exchanged.",
    //             "Exchange Conditions: Products eligible for an exchange must be in a new, unused condition, with all original packaging and tags in place. Eligible Items exchanged with a receipt or gift receipt will be exchanged at the original point of purchase.",
    //             "Warranty: Swarovski offers two (2) years of warranty and for Swarovski Created Diamonds three (3) years of warranty period. For more detailed information on the exchange, warranty or care see our FAQ pages on www.swarovski.com/customerservice or consult your Swarovski retailer. Swarovski reserves the right to modify its exchange and return policy.",
    //         ];

    //         termsText.forEach((t) => {
    //             const wrapped = doc.splitTextToSize(t, pageWidth - 24);
    //             doc.text(wrapped, 12, termY, { lineHeightFactor: 1.2 });
    //             termY += wrapped.length * 4.5 + 2;
    //         });

    //         // ===== PRINT OR DOWNLOAD =====
    //         const blob = doc.output("blob");
    //         const blobUrl = URL.createObjectURL(blob);
    //         const printWindow = window.open(blobUrl, "_blank");
    //         if (printWindow) {
    //             printWindow.onload = () => {
    //                 printWindow.focus();
    //                 printWindow.print();
    //             };
    //         } else {
    //             doc.save(`Invoice_${header.BillNumber}.pdf`);
    //         }
    //     } catch (err) {
    //         console.error("Error generating invoice:", err);
    //     }
    // };


    return (
        <div className="w-full  mx-auto" style={{ width: '100%', marginTop: '10px' }}>
            <div className='w-full mb-2 flex'>
                <h6 className='block uppercase tracking-wide text-black productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif' }}>Sale </h6>
                <div style={{ marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <SearchIcon onClick={toggleSearchInput} style={{ cursor: 'pointer' }} />
                    {showSearchInput && (
                        <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                            type="text"
                            placeholder="Search..."
                            value={searchQuery}
                            onChange={handleSearch}
                            style={{ marginLeft: '10px', width: '200px' }}
                        />
                    )}
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        FromDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={fromDate} onChange={handleFromDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <div style={{ marginRight: '2', maxWidth: '150px', marginLeft: '10px' }}>
                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                        ToDate
                    </label>
                    <input
                        className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                        type="date" value={toDate} onChange={handleToDateChange}
                        style={{ marginTop: '-10px', shadow: 'appearance-none', border: 'rounded', width: '100%', paddingY: '2', paddingX: '3', color: 'gray-700', leadingTight: true, focus: { color: 'gray-600', shadow: 'outline' } }}
                    />
                </div>
                <Button
                    style={{ color: "black", height: '36px', marginLeft: '10px', marginTop: '20px' }}
                    onClick={fetchTableData}
                    className="linkcolor"
                >
                    <IconButton onClick={fetchTableData}>
                        <RefreshIcon style={{ color: 'brown' }} />
                    </IconButton>
                    <span style={{ color: 'brown', fontWeight: 'bolder', marginTop: '-5px' }}>Refresh</span>
                </Button>


            </div>

            <div className="watermark">
                <CopyrightIcon /><b style={{ fontFamily: 'Script Bold Italic' }}>EFFTABS SOLUTIONS LLP</b>
            </div>
            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#58A5B3' }}>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '5%' }}>SL NO</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '7%' }}>BILL DATE</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '10%' }}>BILL NUMBER</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '15%' }}>CUSTOMER</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '13%' }}>PHONE NO</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>AMOUNT</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>CSGT</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>SGST</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>IGST</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', width: '7%', textAlign: 'center' }}>TOTAL</TableCell>
                                <TableCell sx={{ backgroundColor: '#008080', borderBottom: '1px solid #000000', fontWeight: 'bolder', fontSize: '13px', padding: '3px', color: 'whitesmoke', textAlign: 'left' }}>ACTIONS</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: 'whitesmoke' }}>
                            {filteredData.map((item, index) => (
                                <TableRow key={item.id} className={item.IsActive ? '' : 'inactiveRow'}
                                    sx={{
                                        '&:hover': {
                                            backgroundColor: '#B2DFDB', // Change color on hover
                                        },
                                    }}
                                >
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '5px', width: '3%', fontSize: '14px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '5px', width: '7%', fontSize: '14px' }}>{formatDate(item.BillDate)}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '5px', width: '10%', fontSize: '14px' }}>{item.BillPrefix}/{item.BillNumber}/{item.FinYear}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '5px', width: '15%', fontSize: '14px' }}>{item.CustomerName}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '5px', width: '13%', fontSize: '14px' }}>{item.ContactNumber}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '5px', width: '10%', textAlign: 'center', fontSize: '14px' }}>{item.TaxableAmount ? item.TaxableAmount.toFixed(2) : "0.00"} </TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '5px', width: '7%', textAlign: 'center', fontSize: '14px' }}>{item.CGSTAmount ? item.CGSTAmount.toFixed(2) : "0.00"}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '5px', width: '7%', textAlign: 'center', fontSize: '14px' }}>{item.SGSTAmount ? item.SGSTAmount.toFixed(2) : "0.00"}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '5px', width: '7%', textAlign: 'center', fontSize: '14px' }}>{item.IGSTAmount ? item.IGSTAmount.toFixed(2) : "0.00"}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '5px', width: '7%', textAlign: 'center', fontSize: '14px' }}>{item.GrandTotal ? item.GrandTotal.toFixed(2) : "0.00"}</TableCell>
                                    <TableCell sx={{ borderBottom: '1px solid #C0C0C0', padding: '5px', textAlign: 'left', width: '15%' }}>

                                        <IconButton component={Link} to={`/SaleDetails/${item.Id}`}>
                                            <Info style={{ color: 'coral', fontSize: '22px' }} />
                                        </IconButton>

                                        <IconButton onClick={() => handlePrint(item.Id)}>
                                            <PrintIcon style={{ color: 'darkgoldenrod', fontSize: '22px' }} />
                                        </IconButton>


                                        {hasEditMasterPermission && item.IsActive && (
                                            <IconButton component={Link} to={`/SaleEdit/${item.Id}`} color="primary">
                                                <EditIcon style={{ fontSize: '22px' }} />
                                            </IconButton>
                                        )}

                                        {hasDeleteMasterPermission && (
                                            <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))} color="error">
                                                {item.IsActive ? <DeleteIcon style={{ fontSize: '22px' }} /> : <ActivateIcon style={{ color: 'darkolivegreen', fontSize: '22px' }} />}
                                            </IconButton>
                                        )}

                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>

                    </Table>
                </TableContainer>
            </div>
        </div>

    );
}

export default SaleIndex;

